import * as Yup from 'yup'

import { userStatuses } from '../models'

const validateUserStatus = (value?: string): boolean => (value ? userStatuses.includes(value!) : false)

export const validationSchema = Yup.object().shape({
  firstName: Yup.string().trim().min(2).required(),
  surname: Yup.string().trim().min(2).required(),
  email: Yup.string().email().required(),
  userStatus: Yup.string().test('invalid-user-status', 'invalid user status', validateUserStatus),
})
